import styled from 'styled-components';

export const CreateAccountLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AnalyticsCheckboxWrapper = styled.div`
  margin-top: -1rem; // Adjusted to align under Program pills
  padding-bottom: 2rem;
`;
